<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">邀请奖励配置</h1>
    <div class="h_search">
      <label
        >国家：
        <el-select
          v-model="search.countryCode"
          filterable
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option> </el-select
      ></label>
      <label
        >渠道：
        <el-select
          v-model="search.channel"
          style="width: 200px"
          filterable
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in channelList"
            :key="item.channelId"
            :label="item.name"
            :value="item.value"
          >
          </el-option> </el-select
      ></label>
      <label
        >支付方式：
        <el-select
          v-model="search.payType"
          filterable
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="(item, itemIndex) in payTypeList"
            v-bind:key="itemIndex + 99"
            :label="item.lable"
            :value="item.value"
          >
            <span style="float: left">{{ item.lable }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{
              item.value
            }}</span>
          </el-option>
        </el-select></label
      >
      <label
        >是否有效：<el-select v-model="search.status">
          <el-option label="有效" :value="1"></el-option>
          <el-option label="无效" :value="0"></el-option> </el-select
      ></label>
      <el-button type="primary" @click="query" :loading="loading">
        查询
      </el-button>
      <el-button type="warning" @click="operate(1)"> 新增 </el-button>
    </div>

    <el-table
      :data="datalist"
      style="width: 100%"
      v-loading="loading"
      stripe
      border
    >
      <el-table-column prop="countryCode" label="国家"> </el-table-column>
      <el-table-column prop="channel" label="渠道"> </el-table-column>
      <el-table-column prop="payType" label="支付方式">
        <template slot-scope="scope">
          {{
            payTypeList.find((e) => e.value == scope.row.payType)?.lable || scope.row.payType
          }}
        </template>
      </el-table-column>
      <el-table-column prop="firstRebate" label="首充返现比例">
      </el-table-column>
      <el-table-column prop="usualRebate" label="非首充返现比例">
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          {{ scope.row.status == 0 ? '无效' : '有效' }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="operate(2, scope.row)">修改</el-button>
          <el-button size="mini" @click="operate(5, scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page.sync="pageInfo.page"
      layout="total, prev, pager, next"
      background
      @current-change="handleCurrent"
      :total="pageInfo.total"
      class="pagination"
      :page-size="pageInfo.pageSize"
    ></el-pagination>

    <el-dialog
      :title="isAdd ? '新 增' : '编 辑'"
      :visible.sync="dialog"
      width="50%"
      :before-close="handleClose"
    >
      <div class="h_item" v-if="isAdd">
        <span>国家码列表：</span
        ><el-select
          v-model="data.countryCodeList"
          filterable
          placeholder="请选择"
          clearable
          multiple
          collapse-tags
        >
          <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </div>
      <div class="h_item" v-if="isAdd">
        <span>支付方式列表：</span
        ><el-select
          v-model="data.payTypeList"
          filterable
          placeholder="请选择"
          clearable
          multiple
          collapse-tags
        >
          <el-option
            v-for="(item, itemIndex) in payTypeList"
            v-bind:key="itemIndex + 99"
            :label="item.lable"
            :value="item.value"
          >
            <span style="float: left">{{ item.lable }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{
              item.value
            }}</span></el-option
          >
        </el-select>
      </div>
      <div class="h_item" v-if="isAdd">
        <span>渠道：</span
        ><el-select
          v-model="data.channelList"
          filterable
          placeholder="请选择"
          clearable
          multiple
          collapse-tags
        >
          <el-option
            v-for="item in channelList"
            :key="item.channelId"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="h_item">
        <span>首次返利比例：</span
        ><el-input type="text" v-model="data.firstRebateProportion"></el-input>
      </div>
      <div class="h_item">
        <span>通常返利比例：</span
        ><el-input type="text" v-model="data.usualRebateProportion"></el-input>
      </div>
      <div class="h_item">
        <span>是否有效：</span>
        <el-switch
          v-model="data.status"
          active-text="有效"
          inactive-text="无效"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </div>
      <div class="h_item">
        <el-button type="primary" @click="operate(3)" v-if="isAdd"
          >新增</el-button
        >
        <el-button type="primary" @click="operate(4)" v-else>编辑</el-button>
        <el-button type="warning" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { getCountryMore } from '@/utils/normalApi.js'
export default {
  data() {
    return {
      loading: false,
      countryList: [],
      // 渠道列表
      channelList: [],
      payTypeList: [
        { lable: '谷歌内购', value: '0' },
        { lable: '谷歌订阅', value: '1' },
        { lable: '苹果内购', value: '10' },
        { lable: '苹果订阅', value: '9' },
        { lable: '华为内购', value: '11' },
        { lable: '华为订阅', value: '12' },
        { lable: 'vivo内购', value: '13' },
        { lable: '中台支付', value: '14' },
        { lable: '中台订阅', value: '15' },
        { lable: '三方支付', value: '19' },
        { lable: 'tap支付', value: '120' },
        { lable: '茄子支付', value: '125' },
        { lable: 'telegram支付', value: '20' },
      ],
      datalist: [],
      search: {
        countryCode: '',
        payType: '',
        channel: '',
        status: 1,
      },
      pageInfo: {
        page: 1,
        total: 0,
        pageSize: 30,
      },
      dialog: false,
      isAdd: true,
      data: {
        id: '',
        countryCodeList: [],
        payTypeList: [],
        channelList: [],
        firstRebateProportion: '',
        usualRebateProportion: '',
        status: 1,
      },
    }
  },
  methods: {
    async _getCountry() {
      const res = await getCountryMore()
      if (res !== null) {
        this.countryList = [{ country: 'all', countryCode: 'all' }, ...res.countryList]
      }
    },
    //获取渠道选项
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channelList = [
          { channelId: -1, name: 'all', value: 'all' },
          ...res.data,
        ]
      }
    },
    async query() {
      this.loading = true
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.invite_rebate_query +
          `?username=${this.$store.getters.username}&token=${this.$store.getters.token}`,
        {
          ...this.pageInfo,
          ...this.search,
        }
      )
      this.loading = false
      if (res.code != 0) return this.$message(res.msg)
      this.datalist = res.data.data
      this.pageInfo.total = res.data.total
    },
    handleCurrent(newpage) {
      this.pageInfo.page = newpage
      this.query()
    },
    async operate(type, row) {
      if (type == 1) {
        this.dialog = true
        this.isAdd = true
      } else if (type == 2) {
        this.dialog = true
        this.isAdd = false
        this.data.id = row.id
        this.data.firstRebateProportion = row.firstRebate
        this.data.usualRebateProportion = row.usualRebate
        this.data.status = row.status
      } else if (type == 3 || type == 4) {
        let url, data
        if (type == 3) {
          url =
            this.$store.getters.path.invite_rebate_add +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token
          this.data.id = ''
          data = {
            ...this.data,
          }
        } else {
          url =
            this.$store.getters.path.invite_rebate_edit +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token
          data = {
            id: this.data.id,
            firstRebateProportion: this.data.firstRebateProportion,
            usualRebateProportion: this.data.usualRebateProportion,
            status: this.data.status,
            del: 0,
          }
        }

        if (data.firstRebateProportion > 1 || data.usualRebateProportion > 1) {
          return this.$message.error('返利比例不能大于1')
        }
        const { data: res } = await this.$axios.post(url, data)
        if (res.code != 0) return this.$message.error(res.msg)
        this.handleClose()
        this.query()
      } else if (type == 5) {
        this.$confirm('确认删除此项配置', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const { data: res } = await this.$axios.post(
              this.$store.getters.path.invite_rebate_edit +
                '?username=' +
                this.$store.getters.username +
                '&token=' +
                this.$store.getters.token,
              {
                id: row,
                del: 1,
                status: 0,
              }
            )
            if (res.code !== 0) return this.$message.error('删除失败')
            this.$message.success('删除成功')
            this.query()
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            })
          })
      }
    },
    handleClose() {
      this.data = {
        id: '',
        countryCodeList: [],
        payTypeList: [],
        firstRebateProportion: '',
        usualRebateProportion: '',
        status: 1,
      }
      this.dialog = false
    },
  },
  created() {
    this._getCountry()
    this.query()
    this.getChannel()
  },
}
</script>

<style></style>
